import { render } from "./ImagenesPacientes.vue?vue&type=template&id=4856d482&scoped=true"
import script from "./ImagenesPacientes.vue?vue&type=script&lang=js"
export * from "./ImagenesPacientes.vue?vue&type=script&lang=js"

import "./ImagenesPacientes.vue?vue&type=style&index=0&id=4856d482&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4856d482"]])

export default __exports__